import DonationImg from 'assets/img/donate.png'
import messages from 'i18n/messages'
import flowRight from 'lodash/flowRight'
import { makeSelectCurOrg } from 'logic/orgs'
import Link from 'next/link'
import { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import isEmpty from 'lodash/isEmpty'

class DonationsCard extends Component {

  render() {
    const { org } = this.props
    const voucherStyles = {
      backgroundImage: `url(${DonationImg})`,
      paddingTop: '75%',
    }
    return (
      <div className="col-xs-12 col-md-6 col-lg-4 p-0">
        <div className="event-card-item ml-3">
          <div className="event-img" style={voucherStyles} />
          <div className="event-card-body voucher-body">
            <Link href={`/${org.odn}/donate`}>
              <a href={`/${org.odn}/donate`} className="voucher-btn btn btn-primary btn-block">
                {isEmpty(org.portal.donation_text)
                  ? <FormattedMessage {...messages.makeADonation} />
                  : <div>{org.portal.donation_text}</div>
                }
              </a>
            </Link>
          </div>
        </div>
      </div>
    )
  }

}

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
  }, dispatch)
});

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(DonationsCard);
